/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Layout_Header_Help_IntroInputs */



/**
* | output |
* | --- |
* | "Stuck, or found something broken?" |
*
* @param {Layout_Header_Help_IntroInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const layout_header_help_intro = /** @type {((inputs?: Layout_Header_Help_IntroInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_Header_Help_IntroInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kommst du nicht weiter oder ist etwas kaputt?")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Bloqué, ou vous avez trouvé un problème ?")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("卡住了，还是发现了问题？")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("卡關了，還是發現哪裡壞掉？")
	if (locale === "ko") return /** @type {LocalizedString} */ ("막히거나 잘못된 부분을 발견하셨나요?")
	return /** @type {LocalizedString} */ ("Stuck, or found something broken?")
});